 export enum TypeCongeCompteurEnum {
Rtt = 0,
NMoins1 = 1,
N = 2,
}


// WEBPACK FOOTER //
// ./src/dto/GenApi.iNotPaie.Dto/TypeCongeCompteurEnum.ts